import React, {Fragment, useState} from 'react';
import { styled } from '@mui/material/styles';
import { Box } from "@mui/material";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InsightTable from "Samarth Module/components/table/insightTable";
import ShareDeprioritizedCBU from "Samarth Module/components/table/ShareDeprioritizedCBU";
const DeprioritizedCBUCart = ({data})=>{
    const [viewType, setViewType] = useState('Low Priority CBU');
    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
        '& .MuiToggleButtonGroup-grouped': {
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px 5px",
        textTransform: "none",
        width: "12rem",
        color: "#2B2B2B",
        '&:hover': {
            background: "transparent",
        }
        },
        '& .MuiToggleButtonGroup-grouped.Mui-selected': {
        background: "#1F36C7",
        color: "white",
        '&:hover': {
            background: "#1F36C7",
            color: "white"
        }
        }
    }));
    const handleToggleBtnChange = (event, newViewType) => {
        if (newViewType !== null) {
            setViewType(newViewType);
        }
    };
    return (
        <Fragment>
            <Box>
                <div style={{display:"flex",flexDirection:"row-reverse"}}>
                    <div style={{marginBottom:"10px"}}>
                        <StyledToggleButtonGroup
                            color="primary"
                            value={viewType}
                            exclusive
                            onChange={handleToggleBtnChange}
                            aria-label="Platform"
                            size="small"
                        >
                            <ToggleButton value="Low Priority CBU">
                                Low Priority CBU
                            </ToggleButton>
                            <ToggleButton value="Shared Recommendation CBU">
                                Shared Recommendation CBU
                            </ToggleButton>
                        </StyledToggleButtonGroup>
                    </div>
                </div>
                {
                    'Low Priority CBU' === viewType ? <InsightTable type={viewType} data={data[0]} />
                    : <ShareDeprioritizedCBU data={data[1]} />
                }
            </Box>
        </Fragment>
    )
}
export default DeprioritizedCBUCart;